import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Typography,
  Box,
} from '@mui/material';
import { MenuIcon } from './MuiIcons';

interface User {
  name: string;
  email: string;
  avatarUrl?: string;
}

interface HeaderProps {
  onMenuClick: () => void;
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, title = 'Wine War' }) => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  
  let user: User | null = null;
  const stored = localStorage.getItem('user');
  if (stored && stored !== 'undefined' && stored !== null && stored.trim() !== '') {
    try {
      user = JSON.parse(stored);
      if (typeof user !== 'object' || user === null) {
        user = null;
        localStorage.removeItem('user');
      }
    } catch (e) {
      user = null;
      localStorage.removeItem('user');
    }
  }

  useEffect(() => {
    // Update avatar when user changes
    if (user?.avatarUrl) {
      setAvatarUrl(user.avatarUrl);
    }
  }, [user?.avatarUrl]);

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    localStorage.removeItem('user');
    history.push('/');
    handleMenuClose();
  };

  const handleMyAccount = () => {
    history.push('/my-account');
    handleMenuClose();
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        {/* Reserve right-side space to avoid layout shifts on mobile when Drawer opens */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, visibility: user ? 'visible' : 'hidden', minWidth: { xs: 56, sm: 220 }, justifyContent: 'flex-end' }}>
          <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
            {user?.email}
          </Typography>
          <IconButton onClick={handleAvatarClick} color="inherit" size="large">
            <Avatar 
              alt={user?.name}
              src={avatarUrl || undefined}
              sx={{ width: 40, height: 40 }}
            />
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem disabled>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar 
                alt={user?.name}
                src={avatarUrl || undefined}
                sx={{ width: 32, height: 32 }}
              />
              <Box>
                <Typography variant="body2" fontWeight="bold">{user?.name}</Typography>
                <Typography variant="caption" color="text.secondary">{user?.email}</Typography>
              </Box>
            </Box>
          </MenuItem>
          <MenuItem onClick={handleMyAccount}>My account</MenuItem>
          <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;